import Button from 'shared/components/Button'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const ContainerButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
export const ResendButton = styled(Button)`
  width: 185px;
  color: ${props => (props.disabled ? colors.gray7 : colors.green)};
  background: none;
  margin-top: 0px !important;
`
